import { render } from "./sejarah.vue?vue&type=template&id=0caa8206"
import script from "./sejarah.vue?vue&type=script&lang=js"
export * from "./sejarah.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__